import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import { useAdTemplateStyles } from '../templateStyles';
import { Image } from 'components/organisms';
import TemplateFooter from './TemplateFooter';
import clsx from 'clsx';

const Template6 = ({
  content = {
    image: ''
  },
  shopName = ''
}) => {
  const classes = useAdTemplateStyles();

  return (
    <Grid
      container
      item
      justify="space-between"
      component={Paper}
      className={clsx(classes.card, classes.shopListAdCard)}>
      <Grid container item xs={12}>
        <Grid item xs={12}>
          <Image
            docKey={content?.image || ''}
            loadFromStorage={content?.image?.split('/').at(0) === 'images'}
            style={{ height: '13rem' }}
            width="100%"
          />
        </Grid>
      </Grid>
      <TemplateFooter shopName={shopName} />
    </Grid>
  );
};

export default Template6;
